import React, { useState } from 'react';
import { useAuth } from '../../context/AuthContext';
import { Card } from '../../components/ui/card';
import { Input } from '../../components/ui/input';
import { Label } from '../../components/ui/label';
import { Button } from '../../components/ui/button';
import { Badge } from '../../components/ui/badge';
import { Shield, Lock } from 'lucide-react';
import { toast } from '../../hooks/use-toast';

const Security = () => {
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    currentPassword: '',
    newPassword: '',
    confirmPassword: ''
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (formData.newPassword !== formData.confirmPassword) {
      toast({
        title: 'Error',
        description: 'Las contraseñas no coinciden',
        variant: 'destructive'
      });
      return;
    }

    if (formData.newPassword.length < 6) {
      toast({
        title: 'Error',
        description: 'La contraseña debe tener al menos 6 caracteres',
        variant: 'destructive'
      });
      return;
    }

    setLoading(true);

    try {
      // TODO: Implement password change API
      await new Promise(resolve => setTimeout(resolve, 1000));
      
      toast({
        title: '¡Contraseña actualizada!',
        description: 'Tu contraseña ha sido cambiada exitosamente',
      });

      setFormData({
        currentPassword: '',
        newPassword: '',
        confirmPassword: ''
      });
    } catch (error) {
      toast({
        title: 'Error',
        description: 'No se pudo cambiar la contraseña',
        variant: 'destructive'
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="space-y-6">
            <Card className="p-6">
              <div className="flex items-center space-x-3 mb-6">
                <Shield className="w-8 h-8 text-zl-orange" />
                <h1 className="text-2xl font-bold">Seguridad</h1>
              </div>
              
              <div className="space-y-6">
                {/* Change Password */}
                <div>
                  <h3 className="font-semibold text-lg mb-4">Cambiar contraseña</h3>
                  <form onSubmit={handleSubmit} className="space-y-4 max-w-md">
                    <div>
                      <Label htmlFor="currentPassword">Contraseña actual</Label>
                      <Input
                        id="currentPassword"
                        type="password"
                        value={formData.currentPassword}
                        onChange={(e) => setFormData({ ...formData, currentPassword: e.target.value })}
                        required
                      />
                    </div>

                    <div>
                      <Label htmlFor="newPassword">Nueva contraseña</Label>
                      <Input
                        id="newPassword"
                        type="password"
                        value={formData.newPassword}
                        onChange={(e) => setFormData({ ...formData, newPassword: e.target.value })}
                        required
                      />
                    </div>

                    <div>
                      <Label htmlFor="confirmPassword">Confirmar nueva contraseña</Label>
                      <Input
                        id="confirmPassword"
                        type="password"
                        value={formData.confirmPassword}
                        onChange={(e) => setFormData({ ...formData, confirmPassword: e.target.value })}
                        required
                      />
                    </div>

                    <Button
                      type="submit"
                      className="bg-zl-orange hover:bg-zl-orange-600"
                      disabled={loading}
                    >
                      {loading ? 'Actualizando...' : 'Cambiar contraseña'}
                    </Button>
                  </form>
                </div>

                {/* Two-Factor Authentication */}
                <div className="border-t pt-6">
                  <h3 className="font-semibold text-lg mb-4">Autenticación de dos factores</h3>
                  <Card className="p-4 bg-zl-orange-50 border-blue-200">
                    <div className="flex items-start space-x-3">
                      <Lock className="w-5 h-5 text-zl-orange mt-1" />
                      <div>
                        <p className="font-medium text-blue-900 mb-1">
                          Protege tu cuenta con verificación en dos pasos
                        </p>
                        <p className="text-sm text-zl-orange-600 mb-3">
                          Agrega una capa extra de seguridad requiriendo un código de verificación además de tu contraseña.
                        </p>
                        <Button variant="outline" size="sm" className="bg-white">
                          Configurar 2FA
                        </Button>
                      </div>
                    </div>
                  </Card>
                </div>

                {/* Sessions */}
                <div className="border-t pt-6">
                  <h3 className="font-semibold text-lg mb-4">Sesiones activas</h3>
                  <Card className="p-4">
                    <div className="flex items-center justify-between">
                      <div>
                        <p className="font-medium">Sesión actual</p>
                        <p className="text-sm text-gray-500">Última actividad: Ahora</p>
                      </div>
                      <Badge variant="outline" className="bg-green-50 text-green-700">
                        Activa
                      </Badge>
                    </div>
                  </Card>
                </div>
              </div>
            </Card>
    </div>
  );
};

export default Security;
